import type { MutationTree } from 'vuex'
import type { DeviceIntervalsState, SetIntervalPayload } from './types'
import { DEVICE_INTERVALS_MUTATIONS } from './types'

interface IDeviceIntervalsMutations extends MutationTree<DeviceIntervalsState> {
  [DEVICE_INTERVALS_MUTATIONS.SET_INTERVAL](
    state: DeviceIntervalsState,
    payload: SetIntervalPayload
  ): void
  [DEVICE_INTERVALS_MUTATIONS.CLEAR_INTERVAL](state: DeviceIntervalsState): void
  [DEVICE_INTERVALS_MUTATIONS.SET_APP_UPDATE_CALLBACK](
    state: DeviceIntervalsState,
    callback: () => void
  ): void
  [DEVICE_INTERVALS_MUTATIONS.SET_APP_INTERVAL](state: DeviceIntervalsState, interval: number): void
}

const mutations: IDeviceIntervalsMutations = {
  [DEVICE_INTERVALS_MUTATIONS.SET_INTERVAL](state, { id, type }) {
    state.activeIntervalId = id
    state.activeIntervalType = type
  },
  [DEVICE_INTERVALS_MUTATIONS.CLEAR_INTERVAL](state) {
    state.activeIntervalId = null
    state.activeIntervalType = null
  },
  [DEVICE_INTERVALS_MUTATIONS.SET_APP_UPDATE_CALLBACK](state, callback) {
    state.appUpdateCallback = callback
  },
  [DEVICE_INTERVALS_MUTATIONS.SET_APP_INTERVAL](state, interval) {
    state.appInterval = interval
  }
}

export default mutations
